<template>
  <v-card color="grey lighten-5">
    <v-card-title>
      {{ projectStoreData[projectId].name }} Tasks
      <v-spacer></v-spacer>
      <v-btn x-small icon class="ma-2" color="red" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          v-for="(serviceType, i) in projectStoreData[projectId].serviceTypes"
          :key="i"
        >
          <v-card light>
            <v-card-title>
              <v-container>
                <v-row>
                  {{ serviceTypeStoreData[serviceType.id].name }}
                </v-row>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row no-gutters>
                  <v-col cols="12" sm="4">
                    <v-row>
                      <span class="subtitle-2"
                        >Hours:
                        {{
                          serviceTypeSummaryData[serviceType.id].hours.toFixed(
                            2
                          )
                        }}</span
                      >
                    </v-row>
                    <v-row
                      v-if="
                        serviceType.laborRate > 0
                      "
                    >
                      <span class="subtitle-2"
                        >Billed Labor: ${{
                          serviceTypeSummaryData[
                            serviceType.id
                          ].billedLabor.toFixed(2)
                        }}</span
                      >
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-row>
                      <span class="subtitle-2"
                        >Expenses: ${{
                          serviceTypeSummaryData[
                            serviceType.id
                          ].expenses.toFixed(2)
                        }}</span
                      >
                    </v-row>
                    <v-row
                      v-if="
                        serviceType.laborRate > 0
                      "
                    >
                      <span class="subtitle-2"
                        >Billed Expenses: ${{
                          serviceTypeSummaryData[
                            serviceType.id
                          ].billedExpenses.toFixed(2)
                        }}</span
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row no-gutters>
                      <v-col>
                        <v-btn
                          x-small
                          rounded
                          class="ma-2"
                          outlined
                          color="green lighten-1"
                          @click.stop="
                            loadTaskForm('Add', {
                              serviceType: serviceType.id,
                              projectId: projectId
                            })
                          "
                        >
                          <v-icon left>mdi-plus</v-icon> Task
                        </v-btn>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card light flat>
                      <v-card-text>
                        <v-card
                          flat
                          tile
                          light
                          v-for="(taskId, j) in tasksByServiceType[
                            serviceType.id
                          ]"
                          :key="j"
                        >
                          <v-divider v-if="j > 0"></v-divider>
                          <v-card-title>
                            <span class="subtitle-2">
                              {{ tasks[taskId].name }}
                            </span>
                            <v-spacer></v-spacer>
                            <span class="subtitle-2">
                              {{
                                formatDate(tasks[taskId].completionDate)
                              }}</span
                            >
                            <v-spacer></v-spacer>
                            <v-tooltip left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  x-small
                                  icon
                                  class="ma-2"
                                  color="primary"
                                  @click.stop="
                                    loadTaskForm('Edit', tasks[taskId])
                                  "
                                >
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span>Edit Task</span>
                            </v-tooltip>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row no-gutters>
                                <v-col cols="12" sm="4">
                                  <v-row>
                                    <span class="subtitle-2"
                                      >Hours:
                                      {{
                                        tasks[taskId].hours.toFixed(2) +
                                          " / " +
                                          tasks[taskId].estimatedHours.toFixed(
                                            2
                                          )
                                      }}</span
                                    >
                                  </v-row>
                                  <v-row
                                    v-if="
                                      serviceType.laborRate > 0
                                    "
                                  >
                                    <span class="subtitle-2"
                                      >Billed Labor: ${{
                                        tasks[taskId].billedLabor.toFixed(2)
                                      }}</span
                                    >
                                  </v-row>
                                </v-col>
                                <v-col cols="12" sm="4">
                                  <v-row>
                                    <span class="subtitle-2"
                                      >Expenses: ${{
                                        tasks[taskId].expenses.toFixed(2)
                                      }}</span
                                    >
                                  </v-row>
                                  <v-row
                                    v-if="
                                      serviceType.laborRate > 0
                                    "
                                  >
                                    <span class="subtitle-2"
                                      >Billed Expenses: ${{
                                        tasks[taskId].billedExpenses.toFixed(2)
                                      }}</span
                                    >
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              small
                              text
                              color="primary"
                              @click.stop="loadSubmissionDialog(taskId)"
                            >
                              Submissions
                            </v-btn>
                            <!-- <v-btn small text color="primary">
                                Files
                              </v-btn> -->
                          </v-card-actions>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog
      v-model="showTaskForm"
      v-if="showTaskForm == true"
      max-width="800px"
    >
      <DialogForm
        :action="formAction"
        title="Task"
        :data="taskData"
        @update-table="updateTasks"
        @success="successHandler"
        @close="showTaskForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showSubmissionDialog"
      v-if="showSubmissionDialog == true"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          {{ tasks[taskToLoad].name }}
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            class="ma-2"
            color="red"
            @click="showSubmissionDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-container>
                <DataTable
                  sortby="date"
                  title="Time Submissions"
                  :items="submissions[taskToLoad].time"
                  :headers="timeSubmissionHeaders"
                  :loading="loadingTimeSubs"
                  :showadd="false"
                  :showdaterange="false"
                  @error="errorMessage = $event"
                >
                </DataTable>
              </v-container>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-container>
                <DataTable
                  sortby="date"
                  title="Expense Submissions"
                  :items="submissions[taskToLoad].expenses"
                  :headers="expenseSubmissionHeaders"
                  :loading="loadingExpenseSubs"
                  :showadd="false"
                  :showdaterange="false"
                  @error="errorMessage = $event"
                >
                </DataTable>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import DialogForm from "@/components/DialogForm/DialogForm.vue";
import DataTable from "@/components/DataTable/DataTable.vue";
import moment from "moment";

export default {
  name: "Tasks",
  components: { DialogForm, DataTable },
  props: ["projectId", "tasksByServiceType", "tasks"],
  formAction: null,
  data: () => ({
    showTaskForm: false,
    taskData: null,
    submissions: {},
    taskToLoad: null,
    loadingTimeSubs: false,
    loadingExpenseSubs: false,
    showSubmissionDialog: false,
    loading: false,
    loadingText: null,
    successMessage: null,
    errorMessage: null
  }),
  computed: {
    userStoreData() {
      return this.$store.getters.getUsers;
    },
    projectStoreData() {
      return this.$store.getters.getProjects;
    },
    serviceTypeStoreData() {
      return this.$store.getters.getServiceTypes;
    },
    timeSubmissionHeaders() {
      let headers = [];
      headers = [
        {
          text: "Date",
          align: "left",
          value: "date",
          sortable: true
        },
        { text: "User", value: "userName", sortable: false },
        { text: "Duration", value: "duration", sortable: false },
        { text: "Rate", value: "rate", sortable: false },
        { text: "Notes", value: "description", sortable: false },
        { text: "Attachment", value: "attachment", sortable: false }
      ];
      return headers;
    },
    expenseSubmissionHeaders() {
      let headers = [];
      headers = [
        {
          text: "Date",
          align: "left",
          value: "date",
          sortable: true
        },
        { text: "User", value: "userName", sortable: false },
        { text: "Cost", value: "cost", sortable: false },
        { text: "Billed Amount", value: "billedAmount", sortable: false },
        { text: "Description", value: "description", sortable: false },
        { text: "Attachment", value: "attachment", sortable: false }
      ];
      return headers;
    },
    serviceTypeSummaryData() {
      let balances = {};
      for (var serviceType of this.projectStoreData[this.projectId]
        .serviceTypes) {
        let hours = 0;
        let billedLabor = 0;
        let expenses = 0;
        let billedExpenses = 0;
        for (var taskId of this.tasksByServiceType[serviceType.id]) {
          hours = hours + this.tasks[taskId].hours;
          billedLabor = billedLabor + this.tasks[taskId].billedLabor;
          expenses = expenses + this.tasks[taskId].expenses;
          billedExpenses = billedExpenses + this.tasks[taskId].billedExpenses;
        }
        balances[serviceType.id] = {
          hours: hours,
          billedLabor: billedLabor,
          expenses: expenses,
          billedExpenses: billedExpenses
        };
      }
      return balances;
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    }
  },
  methods: {
    successHandler(message) {
      var self = this;
      self.successMessage = message;
      self.showTaskForm = false;
      setTimeout(function() {
        self.successMessage = null;
      }, 2000);
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    loadTaskForm(action, item) {
      this.formAction = action;
      if (item != null) {
        this.taskData = JSON.parse(JSON.stringify(item));
      }
      this.showTaskForm = true;
    },
    loadSubmissionDialog(tId) {
      this.taskToLoad = tId;
      this.loadingTimeSubs = true;
      this.loadingExpenseSubs = true;
      this.showSubmissionDialog = true;
      this.loadSubmissions(tId);
    },
    loadSubmissions(taskId) {
      if (this.submissions[taskId] == null) {
        this.submissions[taskId] = { time: [], expenses: [] };
        let payload = {
          taskId: taskId
        };
        let self = this;
        self.$store.dispatch("getTimeSubmissions", payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message;
          } else {
            for (var timeSubmission of result.data) {
              if (self.userStoreData[timeSubmission.userId] != null) {
                timeSubmission.userName =
                  self.userStoreData[timeSubmission.userId].name;
              }
            }
            self.submissions[taskId].time = result.data;
            self.loadingTimeSubs = false;
          }
        });
        self.$store.dispatch("getExpenseSubmissions", payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message;
          } else {
            for (var expenseSubmission of result.data) {
              if (self.userStoreData[expenseSubmission.userId] != null) {
                expenseSubmission.userName =
                  self.userStoreData[expenseSubmission.userId].name;
              }
            }
            self.submissions[taskId].expenses = result.data;
            self.loadingExpenseSubs = false;
          }
        });
      } else {
        this.loadingTimeSubs = false;
        this.loadingExpenseSubs = false;
      }
    },
    updateTasks(event) {
      this.$emit("update-tasks", event);
    }
  },
  mounted() {}
};
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
